<template>
  <div style="height: 100%; max-width: 500px" class="mx-auto">
    <div>
      <v-stepper
        class="elevation-0 pa-0"
        v-model="step"
        style="border-radius: 0px"
      >
        <v-stepper-content class="pa-0" step="1">
          <step-1 @nextstep="step++"></step-1>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="2">
          <step-2
            v-if="step == 2"
            @prevstep="step--"
            @nextstep="step++"
          ></step-2>
        </v-stepper-content>
        <v-stepper-content class="pa-0" step="3">
          <step-3 @prevstep="step--" @nextstep="step++"></step-3>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      step: 1,
    };
  },
  mounted() {
    if (this.$store.state.redirectview == "PointManager") {
      this.step = 2;
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>